import React, { useState, createContext, useContext, useCallback } from 'react';

import { UseFormReturn } from 'react-hook-form';
import { defaultItemsPerPage, defaultPageNumber } from '../flows/Members/utils';
import { ItemsPerPageOption } from '../components/Pagination';

const MemberContext = createContext({
  activeTab: '',
  setActiveTab: (value: string) => {},
  dependentId: '',
  setDependentId: (value: string) => {},
  isCreateDependent: false,
  setIsCreate: (value: boolean) => {},
  dependentForm: {} as UseFormReturn,
  setDependentForm: (value: UseFormReturn) => {},
  isViewMode: false,
  setIsViewMode: (value: boolean) => {},
  handleClear: () => {},
  isDependentFormValid: false,
  setDependentFormValid: (value: boolean) => {},
  itemsPerPage: defaultItemsPerPage,
  setItemsPerPage: (state: ItemsPerPageOption) => {},
  currentPage: defaultPageNumber,
  setCurrentPage: (state: number) => {}
});

export const MemberContextProvider = ({ children }: { children: React.ReactChild }) => {
  const [activeTab, setActiveTab] = useState<string>('');
  const [dependentId, setDependentId] = useState<string>('');
  const [isCreateDependent, setIsCreate] = useState<boolean>(false);
  const [dependentForm, setDependentForm] = useState<UseFormReturn>({} as UseFormReturn);
  const [isViewMode, setIsViewMode] = useState<boolean>(false);
  const [isDependentFormValid, setDependentFormValid] = useState<boolean>(false);
  const [itemsPerPage, setItemsPerPage] = useState<ItemsPerPageOption>(defaultItemsPerPage);
  const [currentPage, setCurrentPage] = useState<number>(defaultPageNumber);

  const handleClear = useCallback(() => {
    setActiveTab('');
    setDependentId('');
    setIsCreate(false);
  }, []);

  return (
    <MemberContext.Provider
      value={{
        activeTab,
        setActiveTab,
        dependentId,
        setDependentId,
        isCreateDependent,
        dependentForm,
        setDependentForm,
        setIsCreate,
        handleClear,
        isViewMode,
        setIsViewMode,
        isDependentFormValid,
        setDependentFormValid,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        setItemsPerPage
      }}
    >
      {children}
    </MemberContext.Provider>
  );
};

export const useMemberContext = () => {
  return useContext(MemberContext);
};
